
<div class="form-group">
  <div *ngIf="checkViewMode('edit')" class="switch-container">
      <label class="switch">
          <input type="checkbox" [checked]="isChecked" (change)="onValueChange($event)" />
          <span class="slider round"></span>
      </label>
      <label>
          {{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}
          <span *ngIf="getOptionByKey(attribute,'tooltip')"
            class="popover-info"
            [popover]="getOptionByKey(attribute,'tooltip')"
            placement="right"
            container="body"
            triggers="mouseenter:mouseleave">
            <i class="fa fa-question-circle"></i>
          </span>
        </label>
  </div>

  <p *ngIf="checkViewMode('view')">
    <span class="title">{{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle()}}: </span>
    {{ getValue() }}
  </p>
</div>
